import { AppContext } from "@Context/common/general/context";
import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { Box } from "@mui/system";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
//@ts-ignore
import evPos from "ev-pos";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    sx={{ minWidth: "max-content", maxWidth: "max-content" }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: 0,
  },
}));

let parentElement: any = null;
let parentXPos: any = 0;
let parentYPos: any = 0;
const root = document.getElementById("root");

const TooltipService = ({}: {}) => {
  const { state, dispatch } = useContext(AppContext);

  const ref = useRef(null);

  const [TooltipComp, setTooltipComp] = useState<JSX.Element | null>(null);
  const [parentEl, setParentEl] = useState<any>(null);
  const [debug] = useState<boolean>(false);

  const onShowTooltip = ({
    el,
    event,
    tooltipComp,
  }: {
    el: HTMLElement;
    event: MouseEvent;
    tooltipComp: JSX.Element;
  }) => {
    if (el !== parentElement) {
      onHideTooltip();
      parentElement = el;
      setTooltipComp(tooltipComp);
      parentElement = el;
      setParentEl(el);
    } else {
      onMoveTooltip(el, event);
    }
  };

  const onMoveTooltip = (el: HTMLElement, event: MouseEvent) => {
    if (el !== parentElement) return;
    if (root) {
      const parent = document.documentElement;
      const delta = root?.offsetWidth - parent.offsetWidth;
      const pos = evPos(event, parent);
      parentXPos = pos.x - parent.scrollLeft - Math.abs(delta / 2);
      parentXPos =
        parentXPos > parent.scrollWidth - 100
          ? parent.scrollWidth - 120
          : parentXPos;
      parentYPos = pos.y - parent.scrollTop;
    }
  };

  const onHideTooltip = () => {
    if (parentElement) {
      parentElement = null;
      setParentEl(null);
    }
  };

  useEffect(() => {
    state.app.events.showTooltip.uniq(onShowTooltip);
    state.app.events.hideTooltip.uniq(onHideTooltip);
  });

  return (
    <Box
      id={"TOOLTIP-SERVICE"}
      ref={ref}
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 1000,
        pointerEvents: "none",
      }}
    >
      {parentEl && (
        <CustomTooltip
          open={true}
          sx={{ pointerEvents: "none" }}
          title={<Fragment> {TooltipComp} </Fragment>}
        >
          <Box
            sx={{
              pointerEvents: "none",
              position: "absolute",
              left: parentXPos,
              top: parentYPos,
              width: debug ? "20px" : "100px",
              height: debug ? "20px" : "4px",
              backgroundColor: debug ? "red" : "transparent",
            }}
          />
        </CustomTooltip>
      )}
    </Box>
  );
};

export default TooltipService;
